import { IExpression, IExpressionEvaluatorContext } from "@@expressions";
import useObservedExpression from "./useObservedExpression";

type ComponentVisibilityExpressions = {
  Visible?: IExpression;
  Hidden?: IExpression;
};

const hiddenSx: Record<string, any> = { visibility: "hidden" };
const visibleSx: Record<string, any> = {};

export default function useComponentVisibility(
  component: ComponentVisibilityExpressions,
  context: IExpressionEvaluatorContext,
  loggerName: string
): { isVisible: boolean; hiddenSx: Record<string, any> } {
  const [visible] = useObservedExpression<boolean | undefined>(component.Visible, context, loggerName);
  const [hidden] = useObservedExpression<boolean | undefined>(component.Hidden, context, loggerName);

  return {
    isVisible: visible !== false,
    hiddenSx: hidden === true ? hiddenSx : visibleSx,
  };
}
